<template>
    <div>
        <Breadcrumbs />
        <b-card>
            <b-tabs v-model="tabIndex" card>
                <b-tab :title="$t('title.crmContacts')" @click="tabIndex = 0" lazy>
                    <crm-contacts />
                </b-tab>
                <b-tab :title="$t('title.crmDeals')" @click="tabIndex = 1" lazy>
                    <crm-deals />
                </b-tab>
                <b-tab :title="$t('title.crmLeads')" @click="tabIndex = 2" lazy>
                    <crm-leads />
                </b-tab>
                <b-tab :title="$t('title.crmAccounts')" @click="tabIndex = 3" lazy>
                    <crm-accounts />
                </b-tab>
                <b-tab :title="$t('title.crmClientProjects')" @click="tabIndex = 4" lazy>
                    <crm-client-projects />
                </b-tab>
                <b-tab :title="$t('title.crmActivities')" @click="tabIndex = 5" lazy>
                    <crm-activities />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import CrmContacts from "./crmContacts";
import CrmDeals from "./crmDeals";
import crmLeads from "./crmLeads";
import crmAccounts from "./crmAccounts";
import crmClientProjects from "./crmClientProjects";
import crmActivities from "./crmActivities";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
    components: { CrmContacts, CrmDeals, crmLeads, crmAccounts, crmClientProjects, crmActivities, Breadcrumbs },
    data() {
        return {
            tabIndex: 0
        };
    },
    created() {
        if(this.$route.query.resource) {
            let resource = this.$route.query.resource.toString();
            if(resource == 'contacts') {
                this.tabIndex = 0;
            } else if(resource == 'deals') {
                this.tabIndex = 1;
            } else if(resource == 'leads') {
                this.tabIndex = 2;
            } else if(resource == 'accounts') {
                this.tabIndex = 3;
            } else if(resource == 'client_projects') {
                this.tabIndex = 4;
            } else if(resource == 'activities') {
                this.tabIndex = 5;
            }
        }
    }
};
</script>
